module.exports = "https://cdn.littlereply.com/tt/resource/spalsh_holder.e22de0a7eae1eff8db6232d3a4782c5b.png";